import z from 'zod';
import { FanforgeUserJwtClaimsDiscordSchema } from './fanforge-user-jwt-claims-discord';
import { FanforgeUserJwtClaimsWebSchema } from './fanforge-user-jwt-claims-web';

export const FanforgeUserJwtClaimsSchema = z.union([
  FanforgeUserJwtClaimsWebSchema,
  FanforgeUserJwtClaimsDiscordSchema,
]);

export type FanforgeUserJwtClaims = z.infer<typeof FanforgeUserJwtClaimsSchema>;
